
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nl/en/giveback",
      function () {
        return require("private-next-pages/nl/en/giveback.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nl/en/giveback"])
      });
    }
  